import { Injectable } from '@angular/core';
import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse } from '@angular/common/http';

import { adminData } from '@app/modules/authentication/mocks/data/authentication.data';
import { Role } from '@models/authentication/enums/role.enum';

import { AuthenticationService } from '../../services/authentication.service';

import { Observable, throwError as observableThrowError } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AuthenticationInterceptor implements HttpInterceptor {

  constructor() {
  }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return authenticationBackend(req.url, req.method, req) || next.handle(req);
  }
}

export function authenticationBackend(url: string, method: string, request: HttpRequest<any>): Observable<HttpEvent<any>> {
  // Array in local storage for registered users

  const users = populateUsers();
  if (url.endsWith(AuthenticationService.API_LOGIN_BASE_PATH) && method === 'POST') {
    // Get parameters from POST request
    const params: any = request.body;
    // Find if any user matches login credentials
    const filteredUsers = users.filter(user => {
      return user.email === params.email && user.password === params.password;
    });


    // If login details are valid return 200: OK along with user details and a fake JWT Token
    if (filteredUsers.length) {
      const user = filteredUsers[0];

      let payloadData;
      switch (user.role) {
        case Role.Admin:
          payloadData = adminData;
          break;
      }

      return new Observable(resp => {
        resp.next(new HttpResponse<any>({
          status: 200,
          body: {
            token: payloadData,
            statusCode: 200
          }
        }));
        resp.complete();
      });
    } else {
      // Else return 400: Bad request
      return observableThrowError(new HttpErrorResponse({
        error: {message: 'general.messages.401.login.invalidCredentials'},
        status: 401,
        statusText: 'Unauthorized',
        url
      }));
    }
  }

  function populateUsers() {
    const userShadow: any[] = JSON.parse(localStorage.getItem('users')) || [];

    const adminUser = {
      id: 1,
      firstName: 'Fodor',
      lastName: 'Andras',
      email: 'risc@artoil.ro',
      password: '1234',
      role: Role.Admin,
    };

    if (userShadow.length === 0) {
      userShadow.push(adminUser);
    }

    return userShadow;
  }

}
